/**
 * Welcome
 */
export { default as logo } from "./welcome/logo.png";
export { default as welcome1 } from "./welcome/welcome-1.png";
export { default as welcome2 } from "./welcome/welcome-2.png";
export { default as walkthrough1 } from "./welcome/walkthrough1.png";
export { default as walkthrough2 } from "./welcome/walkthrough2.png";
export { default as walkthrough3 } from "./welcome/walkthrough3.png";

/**
 * Accommodation
 */
export { default as block } from "./accommodation/block.png";
export { default as house } from "./accommodation/house.png";

/**
 * Home
 */
export { default as gift } from "./home/gift.png";
export { default as greenTick } from "./home/greenTick.png";
export { default as lightBulb } from "./home/lightBulb.png";
export { default as secondNotificationsReminder } from "./home/secondNotificationReminder.png";
export { default as star } from "./home/star.png";
export { default as welcomeNotifications } from "./home/welcomeNotifications.png";

/**
 * Advertisement
 */
export { default as applePay } from "./advertisement/applePay.png";
export { default as blik } from "./advertisement/blik.png";
export { default as googlePay } from "./advertisement/googlePay.png";
export { default as mastercard } from "./advertisement/mastercard.png";
export { default as przelewy24 } from "./advertisement/przelewy24.png";
export { default as stripe } from "./advertisement/stripe.png";
export { default as visa } from "./advertisement/visa.png";

/**
 * Images for empty screens
 */
export { default as emptyCard } from "./empty/emptyCard.png";
export { default as emptyLocations } from "./empty/emptyLocations.png";
export { default as emptyOpinions } from "./empty/emptyOpinions.png";
export { default as emptyOrders } from "./empty/emptyOrders.png";
export { default as emptyRequests } from "./empty/emptyRequests.png";
export { default as paymentFailed } from "./empty/paymentFailed.png";

/**
 * Other
 */
export { default as rateAppComment } from "./other/rateAppComment.png";
export { default as zigzagDivider } from "./other/zigzagDivider.png";

/**
 * services
 */
export { default as broom } from "./services/broom.png";
export { default as packageBox } from "./services/package.png";
export { default as roller } from "./services/roller.png";

/**
 * Socials
 */
export { default as apple } from "./socials/apple.png";
export { default as facebook } from "./socials/facebook.png";
export { default as google } from "./socials/google.png";

/**
 * Placeholders
 */
export { default as error } from "./placeholders/error.png";
export { default as promoBanner } from "./placeholders/promo-banner.png";
export { default as ratingProfile } from "./placeholders/ratingProfile.png";
export { default as success } from "./placeholders/success.png";

/**
 * Welcome Note
 */
export { default as profile1 } from "./welcomeNote/profile1.png";
export { default as profile2 } from "./welcomeNote/profile2.png";
export { default as profile3 } from "./welcomeNote/profile3.png";
export { default as profile4 } from "./welcomeNote/profile4.png";
